import { type BuiltInIconName, builtInIcons } from './generated/icons';
import type { IconNode } from './types';

/**
 * Apps and system packages can add icons (e.g. faction glyphs) without changing this package:
 *
 *   declare module '@hobbytools/icons' { interface IconRegistry { 'aquila': true } }
 *   registerIcons({ aquila: [...] });
 */
// biome-ignore lint/suspicious/noEmptyInterface: augmented by consumers via declaration merging
export interface IconRegistry {}
export type IconName = BuiltInIconName | Extract<keyof IconRegistry, string>;

const registry = new Map<string, IconNode[]>(Object.entries(builtInIcons));

export function registerIcons(icons: Record<string, IconNode[]>): void {
  for (const [name, nodes] of Object.entries(icons)) registry.set(name, nodes);
}

export function getIcon(name: IconName): IconNode[] | undefined {
  return registry.get(name);
}

export function listIcons(): string[] {
  return [...registry.keys()].sort();
}
